import { axios } from "@Root/API";

export const postAdminRoleCopy = role_id => {
  return axios.post("roles/copy", { role_id });
};
